import { makeStyles } from '@focaldata/cin-ui-components'

const useStyles = makeStyles()({
  audienceCount: {
    width: 'auto'
  }
})

export default useStyles
